import { registerTypeEditor } from "./typeEditorRegistry";
import {
  HeadingEditor,
  TextEditor,
  FooterEditor,
  PaymentTermsEditor,
  LogoEditor,
  ImageEditor,
  SignatureEditor,
  QrCodeEditor,
  BarcodeEditor,
  InvoiceDetailsEditor,
  CustomerInfoEditor,
  CustomElementEditor,
  LineItemsEditor,
  SummaryTableEditor,
  TotalsEditor,
  TwoColumnEditor,
  ThreeColumnEditor,
  FourColumnEditor,
  DividerEditor,
  SpacerEditor,
  PageBreakEditor,
  PageNumberEditor,
  CarriedForwardEditor,
  BroughtForwardEditor,
  KeyValueListEditor,
  TaxDetailsEditor,
  VerticalLayoutEditor,
} from "./editors";

const EDITORS = {
  heading:        HeadingEditor,
  text:           TextEditor,
  companyLogo:    LogoEditor,
  invoiceDetails: InvoiceDetailsEditor,
  customerInfo:   CustomerInfoEditor,
  lineItems:      LineItemsEditor,
  totals:         TotalsEditor,
  summaryTable:   SummaryTableEditor,
  divider:        DividerEditor,
  spacer:         SpacerEditor,
  image:          ImageEditor,
  signature:      SignatureEditor,
  paymentTerms:   PaymentTermsEditor,
  qrCode:         QrCodeEditor,
  barcode:        BarcodeEditor,
  footer:         FooterEditor,
  twoColumn:      TwoColumnEditor,
  threeColumn:    ThreeColumnEditor,
  fourColumn:     FourColumnEditor,
  pageBreak:      PageBreakEditor,
  pageNumber:     PageNumberEditor,
  carriedForward: CarriedForwardEditor,
  broughtForward: BroughtForwardEditor,
  custom:         CustomElementEditor,
  keyValueList:   KeyValueListEditor,
  taxDetails:     TaxDetailsEditor,
  verticalLayout: VerticalLayoutEditor,
};

export function TypeEditor({ element, onUpdate }) {
  const Editor = EDITORS[element.type];
  return Editor ? <Editor props={element.props} onUpdate={onUpdate} /> : null;
}

// Register with the proxy so `editors.jsx` can render us recursively
// (Column/Vertical-Layout child editors) without forming an ES-module cycle.
registerTypeEditor(TypeEditor);
